// @flow
import * as React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import styles from './FeaturedNews.styles.js';
import {FeaturedNewsItem} from 'app/components/FeaturedNewsItem';
import {FeaturedNewsFirst} from 'app/components/FeaturedNewsFirst';

type Props = {
  classes: any,
  list: Array<any>
};

class FeaturedNews extends React.Component<Props> {

  static defaultProps = {
    list: []
  };

  render() {
    const {classes, list} = this.props;
    return (
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <Grid container spacing={16}>
            <Grid item xs={12} sm={8}>
              <FeaturedNewsFirst data={list[0]} />
            </Grid>

            <Grid item xs={12} sm={4}>
              <div className={classes.list}>
                {list && list.map((item, index) => {
                  if (index === 0) {
                    return '';
                  }

                  return (
                    <FeaturedNewsItem key={item.id} data={item} />
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  list: state.featuredNews
});

const Component = connect(mapStateToProps)(withStyles(styles)(FeaturedNews));
export {Component as FeaturedNews};
export default Component;